export default __webpack_public_path__ + "static/media/loading-spinner.c3f9794f.gif";